/*
 * Tupaia
 * Copyright (c) 2017 - 2020 Beyond Essential Systems Pty Ltd
 */
import React from "react";
import styled from "styled-components";
import MuiContainer from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { NAVBAR_HEIGHT } from "./constants";
import { NavBar, SearchBar, Footer, AboutSection } from "./components";
import { useConfig } from "./config/configContext";

const Wrapper = styled.div`
  position: relative;
  background-size: cover;
  background-position: center;
`;

const Container = styled(MuiContainer)`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${NAVBAR_HEIGHT});
  justify-content: space-between;
  padding-bottom: 3rem;
  height: 100%;
  background-color: #0000006f;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 50px;
    padding-right: 50px;
  }
`;

const Main = styled.div`
  position: relative;
  padding-top: 15vh;
  left: 0;

  ${(props) => props.theme.breakpoints.down("sm")} {
    padding-top: 2rem;
  }
`;

const Title = styled(Typography)`
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 3rem;
  margin-bottom: 1.8rem;
  color: white;
  text-shadow: 1px 1px #333;
  max-width: 480px;

  ${(props) => props.theme.breakpoints.down("sm")} {
    line-height: 1.4;
  }
`;

const SubTitle = styled.span`
  color: ${(props) => props.theme.palette.secondary.main};
`;

export const App = () => {
  const { content } = useConfig();

  return (
    <>
      <NavBar />
      <Wrapper style={{ backgroundImage: `url('${content.coverImage}')` }}>
        <Container maxWidth={false}>
          <Main>
            <Title variant="h1">
              Enter your unique test ID to get{" "}
              <SubTitle>your COVID test result</SubTitle>
            </Title>
            <SearchBar />
          </Main>
          <AboutSection />
          <Footer />
        </Container>
      </Wrapper>
    </>
  );
};
